import { render } from "./Register.m.vue?vue&type=template&id=6c16faf2"
import script from "./Register.m.vue?vue&type=script&lang=js"
export * from "./Register.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__